import {Component, EventEmitter, OnInit} from '@angular/core';
import {ExcCoreModule, ExcTranslation} from 'exc-core-v2';
import {ExcPassword} from 'exc-security-v2';
import {ExgModalService} from 'exc-controls-v2';


@Component({
  selector: 'app-modal-change-password',
  templateUrl: './modal-change-password.component.html',
  styles: [
  ]
})
export class ModalChangePasswortComponent extends ExcTranslation implements OnInit {

  excSecurityService = ExcCoreModule.Services().ExcSecurityService;
  oldPwd = '';
  pwd: ExcPassword = ExcCoreModule.Services().ExcPasswordService.New();
  pwdRepeat: ExcPassword = ExcCoreModule.Services().ExcPasswordService.New();

  PasswordChangeSuccess: EventEmitter<any> = new EventEmitter<any>();
  PasswordChangeError: EventEmitter<any> = new EventEmitter<any>();

  constructor(private modalService: ExgModalService) {
    super();
    this.registerEvents();
  }

  registerEvents(): void {
    this.excSecurityService.OnChangePwdSuccess.subscribe(() => {
      this.PasswordChangeSuccess.emit();
      this.modalService.close();
    });
    this.excSecurityService.OnChangePwdError.subscribe((response: any) => {
      this.PasswordChangeError.emit(response);
    });
  }

  ngOnInit(): void {
  }

  changePassword(): void {
    this.excSecurityService.changePassword(this.oldPwd, this.pwd.Value, this.pwdRepeat.Value)
      .subscribe();
  }
  close(): void{
    this.modalService.close();
  }
}
